import React from 'react';

const variantClasses = {
  error: 'bg-red-50 border border-red-200 text-red-700',
  success: 'bg-green-50 border border-green-200 text-green-700',
  warning: 'bg-yellow-50 border border-yellow-200 text-yellow-800',
  info: 'bg-primary-50 border border-primary-100 text-primary-700',
};

const Alert = ({ variant = 'error', className = '', children, ...props }) => (
  <div
    className={`rounded-lg p-3 text-sm ${variantClasses[variant] || ''} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Alert;
